module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido9.333219cd.svg";